import LocalStorage from 'utils/LocalStorage';
import FiltersData from './FiltersData';

/** Children at the next depth (regions use `options`; Hansard Oral/Other uses `nestedOptions`). */
const hierarchyChildTier = (node) => node?.nestedOptions ?? node?.options;

/** Stored tier exists and has at least as many nodes as the canonical tier. */
const storedTierMatchesCanonicalDepth = (storedTier, canonicalTier) =>
  Array.isArray(storedTier) && storedTier.length >= canonicalTier.length;

/**
 * Returns true when stored hierarchy nodes are missing nested option lists (or nested rows)
 * that exist in the canonical FiltersData shape — e.g. Hansard Oral/Other under Regions.
 */
const isParliamentaryHierarchyStale = ({ canonical, stored }) => {
  const canonicalTier = hierarchyChildTier(canonical);
  if (!canonicalTier?.length) {
    return false;
  }
  const storedTier = hierarchyChildTier(stored);
  if (!storedTierMatchesCanonicalDepth(storedTier, canonicalTier)) {
    return true;
  }

  const isNestedBranchStale = (canonicalOption, storedOption) => {
    const nextCanonical = hierarchyChildTier(canonicalOption);
    if (!nextCanonical?.length) {
      return false;
    }
    const nextStored = hierarchyChildTier(storedOption);
    if (!storedTierMatchesCanonicalDepth(nextStored, nextCanonical)) {
      return true;
    }
    return isParliamentaryHierarchyStale({
      canonical: { options: nextCanonical },
      stored: { options: nextStored },
    });
  };

  return canonicalTier.some((canonicalOption, i) => {
    const storedOption = storedTier[i];
    const missingNestedMode =
      Boolean(canonicalOption.parliamentaryNestedMode) && !storedOption?.parliamentaryNestedMode;
    return !storedOption || missingNestedMode || isNestedBranchStale(canonicalOption, storedOption);
  });
};

const enforceUpdateStoredFilters = (mainSection) => {
  let storedFilters = LocalStorage.getItem('contentFilters');
  if (storedFilters && JSON.parse(storedFilters)[mainSection]) {
    let filtersToCompare = JSON.parse(storedFilters)[mainSection];
    let originalFilters = JSON.parse(JSON.stringify(FiltersData()));
    if (filtersToCompare.length < originalFilters.length) {
      return true;
    }
    for (let i = 0; i < filtersToCompare.length; i++) {
      let filter = filtersToCompare[i];
      let originalFilter = originalFilters[i];
      let lengthObjectCondition = Object.keys(filter).length !== Object.keys(originalFilter).length;
      let pagesObjectCondition = originalFilter.pages.length !== filter.pages.length;
      let searchStateCondition = originalFilter.searchState !== filter.searchState;
      if (lengthObjectCondition || pagesObjectCondition || searchStateCondition) {
        return true;
      }
      if (
        originalFilter.type === 'parliamentaryRecordMultipleHierarchy' &&
        isParliamentaryHierarchyStale({ canonical: originalFilter, stored: filter })
      ) {
        return true;
      }
    }
  }
  return false;
};

export default enforceUpdateStoredFilters;
